// components
import { DocumentsComponent } from './documents.component';
import { DocumentsListComponent } from './list/documents.list.component';
import { DocumentsSingleComponent } from './single/documents.single.component';

export const DOCUMENTS_COMPONENTS: any[] = [
  DocumentsComponent,
  DocumentsListComponent,
  DocumentsSingleComponent,
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/documents/index.ts